import { Suspense, lazy, type ReactNode } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { AdminGuard } from "./components/AdminGuard";
import { AdminShell } from "./components/AdminShell";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminNotFoundPage } from "./pages/AdminNotFoundPage";

const TenantsPage = lazy(() =>
  import("./pages/TenantsPage").then((module) => ({
    default: module.TenantsPage,
  })),
);
const PackagesPage = lazy(() =>
  import("./pages/PackagesPage").then((module) => ({
    default: module.PackagesPage,
  })),
);
const AuditPage = lazy(() =>
  import("./pages/AuditPage").then((module) => ({ default: module.AuditPage })),
);
const OperationsPage = lazy(() =>
  import("./pages/OperationsPage").then((module) => ({
    default: module.OperationsPage,
  })),
);
const PlatformAccountsPage = lazy(() =>
  import("./pages/PlatformAccountsPage").then((module) => ({
    default: module.PlatformAccountsPage,
  })),
);
const deferred = (element: ReactNode) => (
  <Suspense
    fallback={
      <div className="admin-route-loading">
        <i />
        <i />
        <i />
      </div>
    }
  >
    {element}
  </Suspense>
);

export const router = createBrowserRouter([
  { path: "/login", element: <AdminLoginPage /> },
  {
    path: "/",
    element: (
      <AdminGuard>
        <AdminShell />
      </AdminGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/tenants" replace /> },
      { path: "tenants", element: deferred(<TenantsPage />) },
      { path: "packages", element: deferred(<PackagesPage />) },
      { path: "audit", element: deferred(<AuditPage />) },
      { path: "operations", element: deferred(<OperationsPage />) },
      { path: "accounts", element: deferred(<PlatformAccountsPage />) },
      { path: "*", element: <AdminNotFoundPage /> },
    ],
  },
]);
